import r from "../managers/braze-instance.js";
import nr from "./feature-flags-provider-factory.js";
export function getFeatureFlag(t) {
  if (!r.rr()) return;
  var e = r.l();
  if (e && !e.Re()) return null;
  var n = nr.o().De();
  return n[t] ? n[t] : null;
}